import React, { useState, useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListeArticles from "./ListeArticles";
import { listeArticles } from "../actions/articlesActions";
import { useNavigate, useLocation } from "react-router-dom";
import "../ToutArticles.css";

const ToutArticles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const Cl = useSelector((state) => state.client);
  const { client } = Cl;
  const arts = useSelector((state) => state.articleListe);
  const { articles, loading } = arts;
  const chariot = useSelector((state) => state.chariot);
  const { chariotListe, loading: loadCh, varGlo } = chariot;

  const [rech, setRech] = useState("");
  const [artRech, setArtRech] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!client) {
      navigate("/");
      return;
    }

    dispatch(listeArticles());
  }, [dispatch, client, navigate]);

  useEffect(() => {
    if (rech === "") {
      setArtRech([]);
    } else {
      const filtered = articles.filter((art) =>
        art.nom.toUpperCase().includes(rech.toUpperCase())
      );
      setArtRech(filtered);
    }
  }, [rech, articles]);

  const renderItem = (articleF) => (
    <div className="article-item-container">
      <ListeArticles
        article={articleF}
        client={client}
        navigate={navigate}
        langue="F"
        source="F"
        wcli={varGlo ? varGlo : client}
      />
    </div>
  );

  return (
    <div className="container">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      )}

      <div className="search-container">
        <input
          type="text"
          placeholder="Article à rechercher"
          value={rech}
          onChange={(e) => setRech(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="articles-grid">
        {(artRech?.length === 0 ? articles : artRech)?.map((article) => (
          <div key={article._id} className="article-card">
            {renderItem(article)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ToutArticles);
